<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="MenuBtnWrap">
        <div class="btn" @click="addCollection">創建合集</div>
      </div>
      <div class="tableWrap">
        <el-table
          :data="totalSongList"
          height="660px"
          stripe
          style="width: 100%"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in totalSongTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
          >
          </el-table-column>
          <el-table-column label="詳情" fixed="right" :width="160">
            <template slot-scope="scope">
              <el-button class="topBtn" @click="goEdit(scope.row)" type="text"
                >編輯
              </el-button>
              <el-button type="text" @click="goDetail(scope.row)"
                >詳情</el-button
              >
              <el-button @click="deleteSong(scope.row.id)" type="text"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
    <el-dialog
      :title="addtype == 'add' ? '創建合集' : '編輯合集'"
      :visible.sync="showMoadl"
      width="7rem"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="cancel"
    >
      <div class="box_flex" style="margin-top: 0">
        <div class="box_text">合集名稱：</div>
        <el-input
          placeholder="請輸入合集名稱"
          class="box_input"
          v-model="form.titleCn"
          maxlength="100"
          v-show="titleFlag == 'cn'"
        ></el-input>
        <el-input
          placeholder="請輸入合集名稱"
          class="box_input"
          v-model="form.title"
          maxlength="100"
          v-show="titleFlag == 'tw'"
        ></el-input>
        <el-input
          placeholder="請輸入合集名稱"
          class="box_input"
          v-model="form.titleEn"
          maxlength="100"
          v-show="titleFlag == 'en'"
        ></el-input>
        <div style="margin-left: 20px; display: flex">
          <div
            :class="titleFlag == item.value ? 'lglabel lbnone' : 'lglabel'"
            v-for="item in languageList"
            :key="item.value"
            @click="titleFlag = item.value"
            :style="{
              backgroundColor: titleFlag == item.value ? '#6C3DEA' : '',
              color: titleFlag == item.value ? '#fff' : '#6C3DEA',
            }"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="box_flex">
        <div class="box_text">合集主圖：</div>
        <el-upload
          style="margin-left: 20px"
          action=""
          :http-request="uploadRequest"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :on-remove="handleRemove"
          :on-error="$errorImage"
          :file-list="fileList"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-change="handleChange"
          :before-upload="$beforePicUpload.bind(this, 0, 2)"
          :limit="1"
          accept=".jpg,.jpeg,.png"
          :multiple="false"
          name="multipartFile"
          list-type="picture-card"
        >
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式(2MB以内)</div>
        </el-upload>
      </div>
      <div class="box_flex">
        <div class="box_text">版權名稱：</div>
        <el-input
          placeholder="請輸入版權名稱"
          class="box_input"
          maxlength="100"
          v-model="form.copyrightCn"
          v-show="copyrightFlag == 'cn'"
        ></el-input>
        <el-input
          placeholder="請輸入版權名稱"
          class="box_input"
          v-model="form.copyright"
          maxlength="100"
          v-show="copyrightFlag == 'tw'"
        ></el-input>
        <el-input
          placeholder="請輸入版權名稱"
          class="box_input"
          v-model="form.copyrightEn"
          maxlength="100"
          v-show="copyrightFlag == 'en'"
        ></el-input>
        <div style="margin-left: 20px; display: flex">
          <div
            :class="copyrightFlag == item.value ? 'lglabel lbnone' : 'lglabel'"
            v-for="item in languageList"
            :key="item.value"
            @click="copyrightFlag = item.value"
            :style="{
              backgroundColor: copyrightFlag == item.value ? '#6C3DEA' : '',
              color: copyrightFlag == item.value ? '#fff' : '#6C3DEA',
            }"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="box_flex">
        <div class="box_text">合集簡介：</div>
        <el-input
          type="textarea"
          placeholder="請輸入合集簡介"
          v-model="form.contentCn"
          style="width: 300px; margin-left: 20px"
          resize="none"
          maxlength="500"
          v-show="introduceFlag == 'cn'"
        />
        <el-input
          type="textarea"
          placeholder="請輸入合集簡介"
          v-model="form.content"
          style="width: 300px; margin-left: 20px"
          resize="none"
          maxlength="500"
          v-show="introduceFlag == 'tw'"
        />
        <el-input
          type="textarea"
          placeholder="請輸入合集簡介"
          v-model="form.contentEn"
          style="width: 300px; margin-left: 20px"
          resize="none"
          maxlength="500"
          v-show="introduceFlag == 'en'"
        />
        <div style="margin-left: 20px; display: flex">
          <div
            :class="introduceFlag == item.value ? 'lglabel lbnone' : 'lglabel'"
            v-for="item in languageList"
            :key="item.value"
            @click="introduceFlag = item.value"
            :style="{
              backgroundColor: introduceFlag == item.value ? '#6C3DEA' : '',
              color: introduceFlag == item.value ? '#fff' : '#6C3DEA',
            }"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="box_flex" style="justify-content: center">
        <el-button @click="cancel()">取消</el-button>
        <el-button
          type="primary"
          v-throttle="{
            fn: () => {
              submitContent();
            },
            time: 2000,
          }"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { throttle } from "../../directives/limit";
export default {
  data() {
    return {
      navBlock: "靈魂的共鳴 ",
      navtitle: "合集列表",
      totalSongList: [],
      showMoadl: false,
      introduceFlag: "cn",
      copyrightFlag: "cn",
      titleFlag: "cn",
      addtype: "add",
      languageList: [
        { label: "簡", value: "cn" },
        { label: "繁", value: "tw" },
        { label: "英", value: "en" },
      ],
      form: {
        title: "",
        titleCn: "",
        titleEn: "",
        img: "",
        content: "",
        contentCn: "",
        contentEn: "",
        copyright: "",
        copyrightCn: "",
        copyrightEn: "",
        id: "",
      },
      totalSongTable: [
        {
          prop: "title",
          label: "合集名稱",
          width: "600px",
        },
        {
          prop: "collectionTotal",
          label: "合集數量",
        },
        {
          prop: "playTotal",
          label: "播放量",
        },
        {
          prop: "createTime",
          label: "創建時間",
        },
      ],
      currentPage: 1,
      total: 0,
      showNoneTips: false,
      dialogVisible: false,
      fileList: [],
    };
  },
  created() {
    this.getList();
  },

  methods: {
    // 获取合集列表
    getList() {
      this.$get(
        `/request/soul/resonance/collection/list?page=${this.currentPage}&size=10`,
        {},
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code === "00000") {
          // if (res.data.list.length === 0) {
          //   this.showNoneTips = true;
          //   return;
          // }
          res.data.list.forEach((v) => {
            v.createTime = this.$getTime(v.createTime);
          });
          this.totalSongList = res.data.list;
          this.total = res.data.allRow;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    }, // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        const fileWay = "resource/image/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then((client) => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              headers: { "Cache-Control": "public" },
            })
            .then(
              (val) => {
                if (val.res.statusCode === 200) {
                  self.fileList.push({
                    name: "img.jpg",
                    url: self.$GLOBAL.picFileUrl + val.name,
                  });
                  console.log("图片路径++" + self.fileList[0].url);
                  //cdn预热
                  self.$cdnFun(self.fileList[0].url).then((res) => {
                    console.log(res);
                    self.form.img = self.fileList[0].url;
                  });
                  document.getElementsByClassName(
                    "el-upload"
                  )[0].style.display = "none";
                  return val;
                } else {
                  option.onError("上传失败");
                }
              },
              (err) => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    // 移除图片的回调函数
    handleRemove(file, fileList) {
      this.$deleteUidItem(file.uid, this.fileList);
      this.form.img = "";
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
    },
    // 上传列表发生变化的回调函数
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    messageTips(msg, type) {
      return this.$message({
        center: true,
        message: msg,
        type: type,
        duration: 2000,
      });
    },
    submitContent() {
      if (
        this.checkText(this.form.title) ||
        this.checkText(this.form.titleCn) ||
        this.checkText(this.form.titleEn)
      ) {
        this.messageTips("合集名稱不能为空", "error");
        return;
      }
      if (!this.form.img) {
        this.messageTips("合集主圖不能为空", "error");
        return;
      }
      if (
        this.checkText(this.form.copyright) ||
        this.checkText(this.form.copyrightCn) ||
        this.checkText(this.form.copyrightEn)
      ) {
        this.messageTips("版權名稱不能为空", "error");
        return;
      }
      if (
        this.checkText(this.form.content) ||
        this.checkText(this.form.contentCn) ||
        this.checkText(this.form.contentEn)
      ) {
        this.messageTips("合集簡介不能为空", "error");
        return;
      }
      this.$post(
        `/request/soul/resonance/collection/operate`,
        this.form,
        this.$GLOBAL.jsonConfig
      )
        .then((res) => {
          this.dialogVisible = true;
          if (res.code === "00000") {
            this.messageTips(
              this.addtype == "add" ? "創建成功" : "編輯成功",
              "success"
            );
            this.form = {};
            this.titleFlag = "cn";
            this.introduceFlag = "cn";
            this.copyrightFlag = "cn";
            this.showMoadl = false;
            this.dialogVisible = false;
            this.getList();
          } else {
            this.$propMessage(res.message, "error", function () {
              this.dialogVisible = false;
            });
          }
        })
        .catch((err) => {
          this.$propMessage(err.message, "error", function () {
            this.dialogVisible = false;
          });
        });
    },
    //编辑
    goEdit(e) {
      //过滤掉e里面collectionTotal，playTotal等属性之后在赋值
      this.form = { ...e };
      this.addtype = "edit";
      delete this.form.collectionTotal;
      delete this.form.playTotal;
      delete this.form.createTime;
      if (this.fileList.length == 0) {
        this.fileList.push({ url: e.img });
      }
      this.showMoadl = true;
      setTimeout(() => {
        document.getElementsByClassName("el-upload")[0].style.display = "none";
      });
    },
    //取消
    cancel() {
      this.showMoadl = false;
      this.fileList = [];
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
    },
    //详情
    goDetail(e) {
      this.$router.push(
        `/collectionDetail?row=${encodeURIComponent(JSON.stringify(e))}`
      );
    },
    deleteSong: throttle(
      function () {
        return true;
      },
      function (id) {
        this.$message.closeAll();
        this.$get(
          `/request/soul/resonance/song/list?page=1&size=10&id=${id}`,
          {},
          this.$GLOBAL.jsonConfig
        ).then((res) => {
          if (res.code === "00000") {
            if (res.data.list.length > 0) {
              this.$Mint.Toast({
                message: "該合集内還有内容，無法刪除",
                type: "warning",
                duration: 2000,
              });
              return;
            } else {
              this.goDel(id);
            }
          } else {
            this.$propMessage(res.message, "error");
          }
        });
      },
      2000
    ),
    //判断文案是否为空
    checkText(text) {
      if (text) {
        if (text.trim() === "") {
          return true;
        } else {
          return false;
        }
      } else if (!text) {
        return true;
      }
    },
    //删除
    goDel(id) {
      this.$confirm("是否刪除該合集？刪除後將無法恢復", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      })
        .then(() => {
          this.$post(
            `/request/soul/resonance/collection/delete`,
            { id },
            this.$GLOBAL.jsonConfig
          ).then((res) => {
            if (res.code === "00000") {
              this.$message({
                message: "刪除成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //創建合集
    addCollection() {
      this.form = {};
      this.fileList = [];
      this.titleFlag = "cn";
      this.introduceFlag = "cn";
      this.copyrightFlag = "cn";
      this.showMoadl = true;
    },
  },
  components: {
    NavBar,
    DiaMess,
  },
};
</script>
<style lang="less" scoped>
.box_flex {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.box_input {
  width: 200px;
  margin-left: 20px;
}
.box_text {
  font-size: 14px;
}
.label_text {
  font-size: 14px;
  cursor: pointer;
  width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  color: #000000;
}
/deep/.el-textarea__inner {
  line-height: 14px !important;
  height: 130px !important;
}
.lglabel {
  height: 38px;
  line-height: 38px;
  text-align: center;
  padding: 0 20px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}
.lbnone {
  border-left-width: 0px;
  border-right-width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jjsoul/collectionList.vue